import AxiosClient from "../../../services/axios.services";

class IndikatorsServices {
  getIndikators = params =>
    AxiosClient.get("/api/app/descriptor_perfil_indicador_descriptor/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  getIndikator = id =>
    AxiosClient.get(`/api/app/descriptor_perfil_indicador_descriptor/${id}/`, {
      headers: { "Content-Type": "application/json" },
  });
  saveIndikator = req =>
    AxiosClient.post("/api/app/descriptor_perfil_indicador_descriptor/", req, {
      headers: { "Content-Type": "application/json" },
    });
  editIndikator = (id, req) =>
    AxiosClient.put(`/api/app/descriptor_perfil_indicador_descriptor/${id}/`, req, {
      headers: { "Content-Type": "application/json" },
    });
  deleteIndikator = id =>
    AxiosClient.delete(`/api/app/descriptor_perfil_indicador_descriptor/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new IndikatorsServices();